import { suggestNextInvoiceNumberForEntity } from "@helpers/invoiceNumber";

export function computeSuggestedInvoiceNumber({
    isEdit,
    isError,
    lastInvoiceNumber,
    entityName,
}: {
    isEdit: boolean;
    isError: boolean;
    lastInvoiceNumber: string | null | undefined;
    entityName: string | null | undefined;
}): string | undefined {
    if (isEdit) {
        return undefined;
    }
    if (isError) {
        return suggestNextInvoiceNumberForEntity({
            last: null,
            entityName,
        });
    }
    if (lastInvoiceNumber === undefined) {
        return undefined;
    }
    return suggestNextInvoiceNumberForEntity({
        last: lastInvoiceNumber,
        entityName,
    });
}
